module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/153ggyg/tc-custom/9789948793076.jpg?1694995829",
      "alt": "This image is the cover for the book أفكار عشوائية"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("أفكار عشوائية\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("الأفكار والتصرُّفات مرتبطان ببعض؛ حيث إنَّ الأفكار تؤثِّر على التصرُّفات ومنها على المعتقدات، وكذلك على منظور الأشخاص للحياة.  لكلٍّ منَّا استقلالية في تفكيره، لكن أساس تشكيل التفكير لربَّما يَبدأ منذ الصغر بسبب العوامل المختلفة التي قد تؤثِّر في منظورنا للحياة لتبني شخصيات متفاوتة في هذا العالم. منطقيًّا وكمعلومة عن دماغ الإنسان، فهو مع اختلاف الأزمان يُمكن تغييرُه أو تطويرُه مِن الناحية الفكرية؛ فمِن ناحية نفسيَّة يستطيع الشخص العادي أو غير المتعلِّم أن يُحلِّل المواقف المختلفة، أو يحلَّ مشكلة معيَّنة يمُرُّ بها؛ فقدرة عقل الإنسان على التعلُّم والتطوُّر والتغيير قدرة رهيبة وممتعة. يُمكن الاتِّفاق على أنَّ الكلَّ مختلف في التفكير، ولكن الكلَّ متشابِه في الوجود على نفس الكَون أو نفس الحياة.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      أنفال السعيد\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("أنفال السعيد شخصية مرحة بسيطة، مُحِبَّة للطبيعة، انطوائية بعض الشيء، وُلِدَت ونشأَت في مملكة البحرين. تحبُّ التجارب والمغامرات وحبَّ الاستطلاع، والاستكشاف الذَّاتي والنفسي.  بدأَتِ الكتابة منذ الصِّغَر، ولكنها توَقَّفَت بعدها؛ لذا كانت تكتب على فترات متفاوتة. تتضَمَّن كتاباتها في أغلب الأوقات بعض الخواطر أو الجُمَل التحفيزيَّة، وهي أيضًا تهوَى الكتابة لدرجة أنَّها تراها ملاذها الوحيد وراحتها النفسيَّة، فهي تراها كأكثر مِن هِواية!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0